

// ChangelogPage.jsx
import React from "react";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import Footer from "../Header & Footer/kfooter"
import img1 from "../Images/Konn3ct Images/v3.jpg";
import img2 from "../Images/Konn3ct Images/v4.jpg";

const logs = [
  {
    version: "kv.0.4.0",

    date: "September 26, 2025",
    title: "Konn3ct v4 Integration",
    image: img2,
    description:
      "Using AI to konn3ct to track issues and respond to messages all in one place.",

    tags: [
      {
        label: "Artificial Intelligence",
        note: "An intelligent, real-time assistant powered by advanced machine learning.",
      },
      {
        label: "Transcibing",
        note: "Real-time, AI-powered captions that transcribe speech instantly.",
      },
      {
        label: "Meeting Summary",
        note: "Automatically captures key points, action items, and decisions from every meeting.",
      },
      {
        label: "Events",
        note: "Create free and paid events.",
      },
      {
        label: "Scheduling",
        note: "A smart, integrated scheduler that allows users to create, manage, and automate meetings.",
      },
      {
        label: "Donations",
        note: "A secure, streamlined donation system that enables users to contribute effortlessly.",
      },
      {
        label: "Improved Whiteboard",
        note: "A real-time, multi-user whiteboard designed for dynamic teamwork.",
      },
      {
        label: "Improved UI/UX",
        note: "A cleaner, more intuitive interface that makes navigation easier and improves the overall user experience.",
      },
    ],
  },
  {
    version: "kv.0.3.0",
    date: "August 02, 2024",
    title: "Konn3ct v3 Integration",
    image: img1,
    description:
      "New palette of keyboard shortcuts accessible across the app, including quick navigation to specific pages or quickly searching for certain objects.",
    tags: [
      {
        label: "Access Code",
        note: "A unique, time-bound code that ensures only authorized users can join a meeting or access restricted areas.",
      },
      {
        label: "Konn3ct Invite",
        note: "An in-app feature that allows users to send meeting or event invitations directly through the Konn3ct platform.",
      },
      {
        label: "WhatsApp Invite",
        note: "A quick-share option that lets users send meeting invites instantly via WhatsApp.",
      },
      {
        label: "Share Emojis",
        note: "Users can send expressive emojis during meetings or chats to enhance communication and engagement.",
      },
      {
        label: "User Dashboard",
        note: "A central hub where users can view meetings, activity history, settings, analytics, and other tools in one place.",
      },
      {
        label: "Streamings",
        note: "Users can stream YouTube or other videos inside the platform while adding real-time commentary or voice-overs.",
      },
      {
        label: "Konn3ct Doc",
        note: "An integrated document tool that allows users to create, share, edit, and collaborate on documents within the app.",
      },
      {
        label: "Take Attendance",
        note: "A feature that automatically records participants present in a meeting, including join/exit timestamps.",
      },
      {
        label: "Breakout Rooms",
        note: "Smaller, separate meeting rooms that allow participants to split into groups for discussions or tasks.",
      },
      {
        label: "2FA User Authentication",
        note: "An additional security layer requiring users to verify their identity using a second method (e.g., OTP, email code).",
      },
      {
        label: "Install App on All Devices",
        note: "Users can install the Konn3ct app on mobile, tablet, and desktop devices for seamless cross-platform access.",
      },
      // {
      //   label: "Breakout Rooms",
      //   note: "Smaller, separate meeting rooms that allow participants to split into groups for discussions or tasks.",
      // },
      // {
      //   label: "Breakout Rooms",
      //   note: "Smaller, separate meeting rooms that allow participants to split into groups for discussions or tasks.",
      // },
    ],
  },

  // add other entries...
];

const ChangelogPage = () => {
 

  return (
    <div className="min-h-screen font-sans text-gray-900 overflow-hidden pt-[64px] sm:pt-[80px] md:pt-[100px]">
      <div
        className="absolute top-0 left-0 w-full h-[61vh] -z-10"
        style={{
          backgroundImage: `
            repeating-linear-gradient(to right, rgba(128, 128, 128, 0.08) 0, rgba(128, 128, 128, 0.08) 1px, transparent 1px, transparent 100px),
            repeating-linear-gradient(to bottom, rgba(128, 128, 128, 0.08) 0, rgba(128, 128, 128, 0.08) 1px, transparent 1px, transparent 100px)
          `,
        }}
      />
      <Konn3ctHeader />

      <section className="text-center max-w-4xl mx-auto mb-16 mt-11">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 leading-snug">
          Changelog
        </h1>
        <p className="mt-4 text-base max-w-2xl mx-auto sm:text-lg text-gray-600">
          Last updated September 26, 2025
        </p>
      </section>
      <div className="max-w-5xl mx-auto px-6 py-10">
        {/* Search Bar */}
        {/* <div className="flex justify-center mb-10">
          <input
            aria-label="search"
            placeholder="Search by Name, Date..."
            className="w-full max-w-md border border-gray-300 rounded-full px-4 py-2 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div> */}

        {/* Entries */}
        <div className="space-y-16">
          {logs.map((item, idx) => (
            <article
              key={idx}
              className="grid grid-cols-1 md:grid-cols-[150px_1fr] gap-6 items-start"
            >
              {/* Left Date */}
              <div className="flex flex-col px-3 py-1">
                <div className="flex justify-center items-center">
                  <span className="inline-flex items-center border gap-1 border-white bg-[#1A4699] rounded-xl px-6 py-1 text-sm font-bold text-white">
                    <span className="w-2 h-2 rounded-full bg-white"></span>
                    {item.version}
                  </span>
                </div>

                <div className="hidden md:block">
                  <time className="text-sm text-gray-600">{item.date}</time>
                </div>
              </div>

              {/* Mobile Date */}
              <div className="md:hidden mb-2">
                <time className="text-sm text-gray-600">{item.date}</time>
              </div>

              {/* Right Content */}
              <div>
                <h2 className="text-xl font-semibold mb-3">{item.title}</h2>

                {/* Image */}
                <div className="relative w-full h-56 rounded-lg mb-3 overflow-hidden">
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                  ) : (
                    <div className="w-full h-full object-cover" />
                  )}
                </div>

                {/* Description */}
                <p className="text-gray-700 mb-3">{item.description}</p>

                {/* Tags */}
                <div className="flex flex-col gap-2">
                  {item.tags.map((tag, i) => (
                    <div key={i} className="flex gap-2 items-center">
                      <span className="inline-flex items-center gap-1 border border-gray-200 bg-gray-50 rounded-full px-3 py-1 text-xs font-medium text-gray-700">
                        <span className="w-2 h-2 rounded-full bg-green-600"></span>
                        {tag.label}
                      </span>
                      <p className="text-sm text-gray-600 leading-tight">
                        {tag.note}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
      <div className="relative z-20 mt-20 space-y-16">
        <Footer />
      </div>
    </div>
  );
};
export default ChangelogPage;
